import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class Headers {
  private readonly values = new Map<string, string>();

  append(name: string, value: string): void {
    this.values.set(name, value);
  }

  set(name: string, value: string): void {
    this.values.set(name, value);
  }

  get(name: string): string | null {
    return this.values.get(name) || null;
  }

  toHttpHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    this.values.forEach((value, key) => {
      headers = headers.set(key, value);
    });
    return headers;
  }
}

export class RequestOptions {
  headers?: Headers;
  params?: HttpParams;
}

export class LegacyHttpResponse {
  constructor(private readonly response: HttpResponse<string>) {}

  get status(): number {
    return this.response.status;
  }

  get statusText(): string {
    return this.response.statusText;
  }

  get headers(): HttpHeaders {
    return this.response.headers;
  }

  json(): any {
    const body = this.response.body || '';
    return body ? JSON.parse(body) : null;
  }

  text(): string {
    return this.response.body || '';
  }

  get _body(): string {
    return this.response.body || '';
  }
}

@Injectable({ providedIn: 'root' })
export class Http {
  constructor(private readonly httpClient: HttpClient) {}

  get(url: string, options?: RequestOptions): Observable<LegacyHttpResponse> {
    return this.httpClient
      .get(url, {
        observe: 'response',
        responseType: 'text',
        headers: options?.headers?.toHttpHeaders(),
        params: options?.params
      })
      .pipe(map((response) => new LegacyHttpResponse(response)));
  }

  post(url: string, body: any, options?: RequestOptions): Observable<LegacyHttpResponse> {
    return this.httpClient
      .post(url, body, {
        observe: 'response',
        responseType: 'text',
        headers: options?.headers?.toHttpHeaders(),
        params: options?.params
      })
      .pipe(map((response) => new LegacyHttpResponse(response)));
  }
}

